import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";
import { CompletedRoomProps } from "../types";

const completedRoomAtom = atom<CompletedRoomProps | undefined>({
    default: undefined,
    key: ATOM_KEY.COMPLETED_ROOM,
});

export const useCompletedRoomValue = () => useRecoilValue(completedRoomAtom);
export const useCompletedRoomState = () => useRecoilState(completedRoomAtom);
export const useSetCompletedRoom = () => useSetRecoilState(completedRoomAtom);
